import "./atoms-v2886.js";
import { millisecondsToSeconds as b, secondsToMilliseconds as R } from "./atoms-v2888.js";
import { calcGeneratorDuration as A, maxGeneratorDuration as w } from "./atoms-v2903.js";
import { generateLinearEasing as B } from "./atoms-v2961.js";
import { clamp as K } from "./atoms-v2905.js";
import { calcGeneratorVelocity as V } from "./atoms-v2962.js";
import { springDefaults as r } from "./atoms-v2963.js";
import { findSpring as j, calcAngularFreq as E } from "./atoms-v2964.js";
const I = ["duration", "bounce"], L = ["stiffness", "damping", "mass"];
function x(t, a) {
  return a.some((s) => t[s] !== void 0);
}
function P(t) {
  let a = {
    velocity: r.velocity,
    stiffness: r.stiffness,
    damping: r.damping,
    mass: r.mass,
    isResolvedFromDuration: !1,
    ...t
  };
  if (!x(t, L) && x(t, I))
    if (t.visualDuration) {
      const s = t.visualDuration, u = 2 * Math.PI / (s * 1.2), m = u * u, g = 2 * K(0.05, 1, 1 - (t.bounce || 0)) * Math.sqrt(m);
      a = {
        ...a,
        mass: r.mass,
        stiffness: m,
        damping: g
      };
    } else {
      const s = j(t);
      a = {
        ...a,
        ...s,
        mass: r.mass
      }, a.isResolvedFromDuration = !0;
    }
  return a;
}
function W(t = r.visualDuration, a = r.bounce) {
  const s = typeof t != "object" ? {
    visualDuration: t,
    keyframes: [0, 1],
    bounce: a
  } : t;
  let { restSpeed: u, restDelta: m } = s;
  const g = s.keyframes[0], f = s.keyframes[s.keyframes.length - 1], d = { done: !1, value: g }, { stiffness: M, damping: T, mass: D, duration: S, velocity: k, isResolvedFromDuration: q } = P({
    ...s,
    velocity: -b(s.velocity || 0)
  }), h = k || 0, o = T / (2 * Math.sqrt(M * D)), c = f - g, i = b(Math.sqrt(M / D)), F = Math.abs(c) < 5;
  u || (u = F ? r.restSpeed.granular : r.restSpeed.default), m || (m = F ? r.restDelta.granular : r.restDelta.default);
  let p;
  if (o < 1) {
    const e = E(i, o);
    p = (n) => {
      const l = Math.exp(-o * i * n);
      return f - l * ((h + o * i * c) / e * Math.sin(e * n) + c * Math.cos(e * n));
    };
  } else if (o === 1)
    p = (e) => f - Math.exp(-i * e) * (c + (h + i * c) * e);
  else {
    const e = i * Math.sqrt(o * o - 1);
    p = (n) => {
      const l = Math.exp(-o * i * n), v = Math.min(e * n, 300);
      return f - l * ((h + o * i * c) * Math.sinh(v) + e * c * Math.cosh(v)) / e;
    };
  }
  const y = {
    calculatedDuration: q && S || null,
    next: (e) => {
      const n = p(e);
      if (q)
        d.done = e >= S;
      else {
        let l = 0;
        o < 1 && (l = e === 0 ? R(h) : V(p, e, n));
        const v = Math.abs(l) <= u, G = Math.abs(f - n) <= m;
        d.done = v && G;
      }
      return d.value = d.done ? f : n, d;
    },
    toString: () => {
      const e = Math.min(A(y), w), n = B((l) => y.next(e * l).value, e, 30);
      return e + "ms " + n;
    }
  };
  return y;
}
export {
  W as spring
};
